import * as React from "react";

const InformationComponent = () => (
    <section className="newsletter-area">
    </section>
);

export default InformationComponent;
